module.exports = __webpack_public_path__ + "img/logo-icon.1c42e408.svg";